<template>
  <div>
    <div>
      <h1 class="mdn-Heading mdn-Heading--sm">Workflows</h1>

      <div class="btn-container">
        <ModosWebBotaoExportarComponent v-if="temWorkflowsRecuperacao" :campos="filtro" @exportar="handleExportarWorkflowsRecuperacao" />
        <button v-if="temWorkflowsRecuperacao" type="button"
          class="btn-toggle mb-3 v-btn v-btn--has-bg theme--light v-size--default primary button-orientation"
          @click="alternarFiltro">
          {{ mostrarFiltro ? 'Ocultar filtros' : 'Mostrar filtros' }}
        </button>
        <ModosWebFiltroInlineCollapseComponent v-if="temWorkflowsRecuperacao" ref="filtroInline" :campos="camposFiltrosComputed" :key="filtroKey"
          :inicialOpen="false" :esconderBotao="true" @open-change="mostrarFiltro = $event"
          @modosWebFormFilterDadosClick="aplicarFiltro" @modosWebFormFilterDadosChange="(d) => { }"
          @modosWebFormFilterLimpar="resetarFiltro" />

        <SGPFormBotaoComponent
          v-if="temWorkflowsInstalacao" color="error darken-1" class="float-right mr-2"
          @click="abrirFiltroAvancado = !abrirFiltroAvancado"
        >
          <v-icon small class="mr-2">mdi-filter</v-icon>
          Filtro Avançado
        </SGPFormBotaoComponent>
      </div>

      <SGPFiltroAvancadoComponent
        v-if="temWorkflowsInstalacao"
        :abrirFiltroAvancado="abrirFiltroAvancado"
        :comFiltroOs="true"
        @sgpFormFilterDadosClick="aplicarFiltroAvancado"
        @mudancaStatusEmit="mudancaStatusFiltro"
      />

      <template v-if="paginacao">
        <SGPPaginacaoComponent :paginacao="paginacao" @sgpAtualizarPaginacao="realizarPaginacao"
          :key="paginacao?.current_page">

          <SGPTabelaComponent v-if="workflowsRecuperacao.length" :colunas="colunas" :dados="workflowsRecuperacao" :usuarioPodeEditar="false"
            :usuarioPodeExcluir="false" :botaoInline="false" :somenteLeitura="true"
            @sgpTabelaModalCadastrarEmit="abrirModalDetalhesAction"
            @sgpTabelaVincularSelecionadoEmit="handleBotaoCustom">
            <template v-slot:item.centro_funcional="{ item }">
              <CentroFuncionalBadge
                :valor="item.centro_funcional"
                :area-tecnica="item.provedor_recuperacao?.area_tecnica"
              />
            </template>
          </SGPTabelaComponent>

          <SGPAlertaComponent v-else />
        </SGPPaginacaoComponent>
      </template>

      <SGPAlertaComponent v-else />
      <SGPLoadingComponent v-if="loadingWorkflowsRecuperacao" />

      <!-- Modal de Detalhes -->
      <SGPModalComponent v-if="abrirModalDetalhes" tamanho="xg" titulo="Detalhes do Workflow" :mostrarFooter="false"
        @sgpModalFechar="fecharModalDetalhes">
        <WorkflowRecuperacaoDetalhesComponent v-if="workflowSelecionado._tipo === 'recuperacao'" :workflow="workflowSelecionado" />
        <WorkflowInstalacaoDetalhesComponent v-else-if="workflowSelecionado._tipo === 'instalacao'" :workflow="workflowSelecionado" />
        <pre v-else>{{ workflowSelecionado }}</pre>
      </SGPModalComponent>

      <SGPModalComponent v-if="abrirModalVincular" tamanho="lg" titulo="Vincular Tarefa ao Ticket"
        :mostrarFooter="false" @sgpModalFechar="fecharModalVincular">
        <VincularTarefaModalComponent :workflowRecuperacao="workflowSelecionado"
          @sgpModalFechar="fecharModalVincular" />
      </SGPModalComponent>
    </div>
  </div>
</template>

<style scoped>
.btn-container {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  justify-content: flex-end !important;
  flex-wrap: wrap;
  align-items: flex-start;
}
</style>
<script>
import { mapActions, mapGetters } from 'vuex'
import VincularTarefaModalComponent from '../components/VincularTarefaModalComponent.vue'
import WorkflowRecuperacaoDetalhesComponent from '../components/WorkflowRecuperacaoDetalhesComponent.vue'
import WorkflowInstalacaoDetalhesComponent from '../components/WorkflowInstalacaoDetalhesComponent.vue'
import ModosWebFiltroInlineCollapseComponent from '@/common/modosweb-components/ModosWebFiltroInlineCollapseComponent.vue'
import ModosWebBotaoExportarComponent from '@/common/modosweb-components/ModosWebBotaoExportarComponent.vue'
import { normalizarWorkflow } from '../helpers/workflowNormalizer'
import { colunasParaTipos } from '../helpers/workflowColunas'
import { rotuloTelmex } from '@/common/helpers/ProvedorTelmex'
import moduleReload from '@/common/mixins/module-reload.js'
import { CTRL_MODULOS } from '@/common/boot/Constantes'
import CentroFuncionalBadge from '@/common/sgp-components/CentroFuncionalBadge.vue'
import { centroFuncionalOpcoes } from '@/common/helpers/centroFuncional'

export default {
  name: 'PcoWorkflowsPage',

  mixins: [moduleReload],

  components: {
    VincularTarefaModalComponent,
    WorkflowRecuperacaoDetalhesComponent,
    WorkflowInstalacaoDetalhesComponent,
    ModosWebFiltroInlineCollapseComponent,
    ModosWebBotaoExportarComponent,
    CentroFuncionalBadge,
  },

  data() {
    return {
      mostrarFiltro: false,
      workflowsSelecionados: [],
      abrirModalDetalhes: false,
      abrirModalVincular: false,
      workflowSelecionado: {},
      filtro: {},
      filtroKey: 1,
      abrirFiltroAvancado: false,
      filtroAvancado: {}
    }
  },
  created() {
    this.listarWorkflowsRecuperacao(this.montarParametros());
  },
  computed: {
    ...mapGetters('ctrlWorkflowRecuperacao', ['listaDeWorkflowsRecuperacao', 'loadingWorkflowsRecuperacao', 'paginacao']),
    ...mapGetters('ctrlModulos', ['moduloAtivo']),
    ...mapGetters('login', ['isProvedorTelmex']),

    camposFiltrosComputed() {
      const campos = [
        { name: 'numero_rec', type: 'text', label: 'Número REC' },
        { name: 'numero_protocolo', type: 'text', label: 'Número Protocolo' },
        { name: 'cliente_final', type: 'text', label: 'Cliente Final' },
        { name: 'centro_funcional', type: 'select', label: 'Centro Funcional', options: centroFuncionalOpcoes },
        { name: 'provedor_nome', type: 'text', label: 'Provedor' },
        { name: 'designacao_claro', type: 'text', label: 'Designação Claro' },
        { name: 'data_abertura_ticket', type: 'date', label: 'Data abertura' },
        { name: 'finalized_at', type: 'range', label: 'Data fechamento' },
        { name: 'status', type: 'text', label: 'Status' },
        { name: 'uf', type: 'text', label: 'UF' },
        { name: 'responsavel', type: 'text', label: 'Gestor - responsável' },
        { name: 'tarefa_vinculada', type: 'select', label: 'Tarefa vinculada', options: [{ value: true, text: 'Sim' }, { value: false, text: 'Não' }] },
        { name: 'os', type: 'text', label: 'OS'}
      ]

      return campos.map(c => ({ ...c, label: rotuloTelmex(c.name, c.label, this.isProvedorTelmex) }))
    },

    workflowsRecuperacao() {
      return this.listaDeWorkflowsRecuperacao.map(normalizarWorkflow)
    },

    temWorkflowsRecuperacao() {
      return this.moduloAtivo == CTRL_MODULOS.RECUPERACAO
    },

    temWorkflowsInstalacao() {
      return this.moduloAtivo == CTRL_MODULOS.INSTALACAO
    },

    colunas() {
      const tipos = new Set(this.workflowsRecuperacao.map(w => w._tipo))
      return colunasParaTipos(tipos, this.isProvedorTelmex)
    }
  },

  methods: {
    ...mapActions('ctrlWorkflowRecuperacao',
      [
        'listarWorkflowsRecuperacao',
        'exportarWorkflowsRecuperacao'
      ]),

    alternarFiltro() {
      this.mostrarFiltro = !this.mostrarFiltro;
      if (this.$refs.filtroInline && this.$refs.filtroInline.toggleOpen) {
        this.$refs.filtroInline.toggleOpen();
      }
    },

    async handleExportarWorkflowsRecuperacao(dados) {
      const payload = {
        ...dados.filtro,
        formato: dados.formato
      };
      await this.exportarWorkflowsRecuperacao(payload);
    },

    resetarFiltro() {
      this.filtro = {};

      this.listarWorkflowsRecuperacao(this.montarParametros({
        page: 1,
        current_page: 1
      }));

      this.filtroKey++;
    },

    async aplicarFiltro(dados) {
      this.filtro = dados || {};
      await this.listarWorkflowsRecuperacao(this.montarParametros({
        page: 1,
        current_page: 1
      }));
    },

    gerenciadorDeSelecionados(selecionados) {
      this.workflowsSelecionados = selecionados;
    },

    abrirModalDetalhesAction(workflow) {
      this.workflowSelecionado = workflow;
      this.abrirModalDetalhes = true;
    },

    handleBotaoCustom(workflow) {
      this.workflowSelecionado = workflow;
      this.abrirModalVincular = true;
    },

    fecharModalDetalhes() {
      this.abrirModalDetalhes = false;
      this.workflowSelecionado = {};
    },

    fecharModalVincular() {
      this.abrirModalVincular = false;
      this.workflowSelecionado = {};
      this.listarWorkflowsRecuperacao(this.montarParametros());
    },

    montarParametros(extra = {}) {
      const { centro_funcional, ...filtro } = this.filtro
      return {
        per_page: this.paginacao?.per_page || 20,
        page: this.paginacao?.current_page || 1,
        current_page: this.paginacao?.current_page || 1,
        ...filtro,
        ...(centro_funcional ? { centro_funcional } : {}),
        ...this.filtroAvancado,
        ...extra,
      }
    },

    realizarPaginacao(paginate) {
      const current = paginate.current_page || 1
      const perPage = paginate.per_page || this.paginacao?.per_page || 20
      this.listarWorkflowsRecuperacao(
        this.montarParametros({
          page: current,
          current_page: current,
          per_page: perPage
        })
      )
    },

    reloadData() {
      this.filtro = {};
      this.filtroKey++;
      this.listarWorkflowsRecuperacao(this.montarParametros({ page: 1, current_page: 1 }));
    },

    async aplicarFiltroAvancado(dados) {
      this.filtroAvancado = dados;
      const payload = {
        ...this.filtroAvancado,
        page: 1,
        per_page: this.paginacao?.per_page || 20,
      };

      await this.listarWorkflowsRecuperacao(payload);
      this.abrirFiltroAvancado = false;
    },

    mudancaStatusFiltro(val) {
      this.abrirFiltroAvancado = val;
    },
  }
}
</script>
